import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import Vue from 'vue'

// initial state
const state = {
  sepa: [],
  loading: false,
  error: null
}

// getters
const getters = {
  sepa (state) {
    return state.sepa
  },
  einSepa: (state) => (id) => {
    return state.sepa.find(einSepa => einSepa.id === id)
  },
  loading (state) {
    return state.loading
  },
  error (state) {
    return state.error
  }
}

// actions
const actions = {
  loadSepa ({commit}) {
    commit('setLoading', true)
    console.log('Sepa laden...')
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('sepa').get()
    .then(snapshot => {
      const sepa = []
      snapshot.forEach(doc => {
        sepa.push({
          ...doc.data(),
          id: doc.id
        })
        commit('setLoadedSepa', sepa)
        commit('setLoading', false)
      })
    })
    .catch(
      (error) => {
        console.log(error)
        commit('setLoading', false)
      }
    )
  },
  createEinSepa ({commit, getters}, payload) {
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('sepa').add(payload)
      .then(key => {
        commit('createEinSepa', {
          ...payload,
          id: key.id
        })
      })
      .catch((error) => {
        console.log(error)
      })
  // Reach out to firebase and store it
  },
  deleteEinSepaData ({commit}, payload) {
    commit('setLoading', true)
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('sepa').doc(payload).delete()
    .then(() => {
      commit('setLoading', false)
      commit('deleteEinSepa', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
    commit('setLoading', false)
  },
  updateEinSepaData ({commit}, payload) {
    commit('setLoading', true)
    const updateObj = {}
    Object.keys(payload).forEach(key => {
      if (payload[key] !== undefined) {
        updateObj[key] = payload[key]
      }
    })
    firebase.firestore().collection('vereine').doc(Vue.prototype.$vars.verbindung).collection('sepa').doc(payload.id).update(updateObj)
    .then(() => {
      commit('setLoading', false)
      commit('updateEinSepa', payload)
    })
    .catch(error => {
      console.log(error)
      commit('setLoading', false)
    })
  }
}

// mutations
const mutations = {
  setLoadedSepa (state, payload) {
    state.sepa = payload
  },
  createEinSepa (state, payload) {
    state.sepa.push(payload)
  },
  updateEinSepa (state, payload) {
    const einSepa = state.sepa.find(einSepa => {
      return einSepa.id === payload.id
    })
    Object.keys(payload).forEach(key => {
      if (payload[key]) {
        einSepa[key] = payload[key]
      }
    })
  },
  deleteEinSepa (state, payload) {
    let array = state.sepa
    for (var i = 0; i < array.length; i++) {
      if (array[i].id === payload) {
        array.splice(i, 1)
      }
    }
    state.sepa = array
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setError (state, payload) {
    state.error = payload
  },
  clearError (state) {
    state.error = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sepa_alt.js